import { t } from "ttag";

import { AdminNavItem } from "metabase/admin/components/AdminNav";
import { UpsellGem } from "metabase/common/components/upsells/components";
import { useSetting } from "metabase/common/hooks";
import type { PaletteSubPath } from "metabase/palette/types";

export function getMetabotAnalyticsNavItems() {
  return <MetabotAnalyticsNavItems />;
}

export function getMetabotAnalyticsUpsellNavItems() {
  return <MetabotAnalyticsUpsellNavItems />;
}

// Mirrors MetabotAnalyticsNavItems' own sub-page list above so every
// sub-page reachable by browsing Admin > AI's sidebar is also reachable by
// name from the global command palette (WCAG 2.4.5 Multiple Ways).
export function useMetabotAnalyticsPaths(): PaletteSubPath[] {
  const areAiFeaturesEnabled = useSetting("ai-features-enabled?");

  if (!areAiFeaturesEnabled) {
    return [];
  }

  const usageAuditingLabel = `${t`AI`} - ${t`Usage auditing`}`;

  return [
    {
      key: "ai-usage-auditing-stats",
      name: `${usageAuditingLabel} - ${t`Stats`}`,
      path: "/admin/metabot/usage-auditing",
    },
    {
      key: "ai-usage-auditing-conversations",
      name: `${usageAuditingLabel} - ${t`Conversations`}`,
      path: "/admin/metabot/usage-auditing/conversations",
    },
  ];
}

function MetabotAnalyticsNavItems() {
  const isConfigured = useSetting("llm-metabot-configured?");
  const areAiFeaturesEnabled = useSetting("ai-features-enabled?");

  if (!areAiFeaturesEnabled) {
    return null;
  }

  return (
    <AdminNavItem
      icon="audit"
      label={t`Usage auditing`}
      folderPattern="usage-auditing"
      disabled={!isConfigured}
    >
      <AdminNavItem
        label={t`Stats`}
        path="/admin/metabot/usage-auditing"
        disabled={!isConfigured}
      />
      <AdminNavItem
        label={t`Conversations`}
        path="/admin/metabot/usage-auditing/conversations"
        disabled={!isConfigured}
      />
    </AdminNavItem>
  );
}

function MetabotAnalyticsUpsellNavItems() {
  return (
    <AdminNavItem
      icon="audit"
      label={t`Usage auditing`}
      path="/admin/metabot/usage-auditing"
      rightSection={<UpsellGem.New size={14} />}
    />
  );
}
